// @flow

import React, { createContext, useContext, useReducer } from 'react';

import reducer from './CostCalculatorForm.reducers';

const CostCalculatorFormStateContext = createContext(null);

const CostCalculatorFormDispatchContext = createContext(null);

export const useFormStateContext = () => useContext(CostCalculatorFormStateContext);

export const useFormDispatchContext = () => useContext(CostCalculatorFormDispatchContext);

export const CostCalculatorFormProvider = ({ children, questions }: Props) => {
  const stateQuestions = questions.map((q, index) => ({
    ...q,
    index: index + 1,
    isAnswered: false,
  }));

  const [state, dispatch] = useReducer(reducer, {
    currentQuestionIndex: 1,
    questions: stateQuestions,
  });

  return (
    <CostCalculatorFormStateContext.Provider value={state}>
      <CostCalculatorFormDispatchContext.Provider value={dispatch}>
        {children}
      </CostCalculatorFormDispatchContext.Provider>
    </CostCalculatorFormStateContext.Provider>
  );
};
